import React, { useState } from 'react';
import { Siren, AlertOctagon, WifiOff } from 'lucide-react';
import AlarmsTab from './AlarmsTab';
import LostDevicesTab from './LostDevicesTab';

const NSPage = () => {
    const [activeTab, setActiveTab] = useState(() => {
        const saved = localStorage.getItem('nsActiveTab');
        if (saved === 'alarms' || saved === 'lost') {
            localStorage.removeItem('nsActiveTab');
            return saved;
        }
        return 'lost';
    });
    const [lostCount, setLostCount] = useState(0);       // счётчик для бейджа на вкладке

    const tabs = [
        { id: 'alarms', label: 'Аварии и предупреждения', icon: AlertOctagon },
        { id: 'lost', label: 'Устройства без связи', icon: WifiOff, badge: lostCount }
    ];

    return (
        <div className="space-y-4 sm:space-y-6">
            {/* ===== Общая шапка ===== */}
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2">
                    <span className="relative inline-flex">
                        <Siren className="w-6 h-6 sm:w-7 sm:h-7 text-red-400" strokeWidth={2} />
                        {lostCount > 0 && (
                            <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                            </span>
                        )}
                    </span>
                    Нештатные ситуации
                </h2>
                <p className="text-slate-400 text-xs sm:text-sm mt-1">
                    Контроль аварий и потери связи с узлами учета
                </p>
            </div>

            {/* ===== Переключатель вкладок ===== */}
            <div className="flex flex-col sm:flex-row gap-1.5 bg-slate-800 border border-slate-700 rounded-xl p-1.5">
                {tabs.map(tab => {
                    const Icon = tab.icon;
                    const active = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium transition flex items-center justify-center gap-2 ${active
                                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/20'
                                    : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
                                }`}
                        >
                            <Icon className="w-4 h-4" />
                            <span>{tab.label}</span>
                            {tab.badge > 0 && (
                                <span className={`ml-1 px-1.5 py-0.5 rounded-full text-[11px] font-bold tabular-nums ${active ? 'bg-white/20 text-white' : 'bg-red-500/20 text-red-400'
                                    }`}>
                                    {tab.badge}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>

            {/* ===== Контент вкладок =====
                Обе вкладки смонтированы постоянно, неактивная скрыта через hidden —
                это позволяет не перезагружать список устройств при переключении. */}
            <div className={activeTab === 'alarms' ? '' : 'hidden'}>
                <AlarmsTab />
            </div>
            <div className={activeTab === 'lost' ? '' : 'hidden'}>
                <LostDevicesTab onCountChange={setLostCount} />
            </div>
        </div>
    );
};

export default NSPage;